import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { STORAGE_KEYS, DEFAULT_THEME, ThemeName } from '../../lib/config'

export type { ThemeName }

interface ThemeState {
  current: ThemeName
}

const getInitialTheme = (): ThemeName => {
  try {
    const stored = localStorage.getItem(STORAGE_KEYS.theme) as ThemeName | null
    if (stored) return stored
  } catch {}
  return DEFAULT_THEME
}

const themeSlice = createSlice({
  name: 'theme',
  initialState: (): ThemeState => ({
    current: getInitialTheme(),
  }),
  reducers: {
    setTheme: (state, action: PayloadAction<ThemeName>) => {
      state.current = action.payload
      // Persist to localStorage
      try {
        localStorage.setItem(STORAGE_KEYS.theme, action.payload)
      } catch {}
      // Apply to DOM
      document.documentElement.setAttribute('data-theme', action.payload)
    },
  },
})

export const { setTheme } = themeSlice.actions
export default themeSlice.reducer
